import { render, staticRenderFns } from "./lottery-wheel.vue?vue&type=template&id=17274602&scoped=true&"
import script from "./lottery-wheel.vue?vue&type=script&lang=js&"
export * from "./lottery-wheel.vue?vue&type=script&lang=js&"
import style0 from "./lottery-wheel.vue?vue&type=style&index=0&id=17274602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17274602",
  null
  
)

export default component.exports